import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuditTrialDetails } from '../../../shared/models/audits/audit-trial-details';
import { SharedConstants } from '../../../shared/constants/shared-constants';

@Component({
  selector: 'app-skill-audit-trial',
  templateUrl: './skill-audit-trial.component.html',
  styleUrls: ['./skill-audit-trial.component.scss']
})
export class SkillAuditTrialComponent implements OnInit, OnChanges {
  @Input() auditTrailData: AuditTrialDetails[] = [];

  auditAttributeDetailsOfTransaction!: AuditTrialDetails;
  skillAuditSummaryDetails: AuditTrialDetails[] = [];
  isDataLoaded = false;

  constructor(private messageService: MessageService) {}

  ngOnInit(): void {
    this.initializeAuditData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['auditTrailData']) {
      this.initializeAuditData();
    }
  }

  showAuditItemDetails(auditAttributeDetails: AuditTrialDetails): void {
    this.auditAttributeDetailsOfTransaction = auditAttributeDetails;
  }

  private initializeAuditData(): void {
    if (this.auditTrailData && this.auditTrailData.length > 0) {
      this.skillAuditSummaryDetails = this.auditTrailData;
      this.auditAttributeDetailsOfTransaction = this.auditTrailData[0];
      this.isDataLoaded = true;
      this.notifyMissingAttributesIfAny();
    } else {
      this.skillAuditSummaryDetails = [];
      this.isDataLoaded = false;
    }
  }

  private hasMissingAttributes(): boolean {
    return !!this.skillAuditSummaryDetails?.some(
      d => d?.attributeDetails?.some(a => a?.isAttributeValueMissing)
    );
  }

  private notifyMissingAttributesIfAny(): void {
    if (this.hasMissingAttributes()) {
      this.messageService.add({
        severity: SharedConstants.Severity_Warning,
        summary: SharedConstants.AuditTrail_AttributeMissing_Message,
        life: 20000
      });
    }
  }
}
